import gql from "graphql-tag";

export const MY_HR_SEND_TEMPORARY_PASSWORD = gql`
  mutation sendTemporaryPassword($email: String!, $locale: String!) {
    sendTemporaryPassword(email: $email, locale: $locale) {
      status
      statusMessage
    }
  }
`;
